<template>
  <div>
    <!-- begin breadcrumb -->
    <breadcrumb activeName="订单管理" :breadcrumbItem="[{to:'/orders/list',name:'订单管理'}]"></breadcrumb>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      商品订单
      <small>订单管理...</small>
    </h1>
    <!-- end page-header -->
    <panel title="订单列表">
      <Row :gutter="5">
        <Col span="5">
          <Input v-model="filterCond.goods_name" placeholder="商品名称"></Input>
        </Col>
        <Col span="3">
          <Select v-model="filterCond.orderstatus">
            <Option :value="99" label="全部"></Option>
            <Option :value="0" label="未收货"></Option>
            <Option :value="1" label="已收货"></Option>
            <Option :value="-1" label="已取消"></Option>
            <Option :value="-2" label="已删除"></Option>
          </Select>
        </Col>
        <Col span="3">
          <Select v-model="filterCond.paystatus">
            <Option :value="99" label="全部"></Option>
            <Option :value="0" label="未付款"></Option>
            <Option :value="1" label="已付款"></Option>
            <Option :value="2" label="已退款"></Option>
          </Select>
        </Col>
        <Col span="3">
          <Select v-model="filterCond.shippingstatus">
            <Option :value="99" label="全部"></Option>
            <Option :value="0" label="未发货"></Option>
            <Option :value="1" label="已发货"></Option>
          </Select>
        </Col>
        <Col span="4">
          <DatePicker
            v-model="orderdate"
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom-end"
            placeholder="订单日期"
            style="width: 100%"
          ></DatePicker>
        </Col>
        <Col span="3">
          <Select v-model="filterCond.ordertype">
            <Option value="goods">商品订单</Option>
            <Option value="recharger">充值订单</Option>
            <Option value="all">不限制</Option>
          </Select>
        </Col>
        <Col span="3">
          <Button type="primary" class="btn btn-theme" @click="fn_query">查询</Button>
        </Col>
      </Row>
      <Table class="m-t-10" :columns="columns" :data="datas">
        <template slot="ordertype" slot-scope="{row}">
          <span v-if="row.ordertype =='goods'">商品订单</span>
          <span v-else-if="row.ordertype =='recharger'">充值订单</span>
        </template>

        <template slot="orderstatus" slot-scope="{row}">
          <span v-if="row.orderstatus == -1" style="color:red">取消</span>
          <span v-else-if="row.orderstatus == -2" style="color:red">删除</span>
          <span v-else-if="row.orderstatus == 0">未收货</span>
          <span v-else-if="row.orderstatus == 1" style="color:green">
            已收货
            <i class="fa fa-check"></i>
          </span>
        </template>

        <template slot="users" slot-scope="{row}">
          <p>{{row.users.unionid}}</p>
          <p>{{row.users.name}}</p>
        </template>

        <template slot="paystatus" slot-scope="{row}">
          <span v-if="row.paystatus == 0">未付款</span>
          <span v-else-if="row.paystatus == 1" style="color:green">
            <a href="javascript:void(0)" @click="fn_show_payuser(row)">
              已付款
              <i class="fa fa-check"></i>
            </a>
          </span>
          <span v-else-if="row.paystatus == 2" style="color:red">
            已退款
            <i class="fa fa-times"></i>
          </span>
        </template>
        <template slot="shippingstatus" slot-scope="{row}">
          <span v-if="row.shippingstatus == 0">未发货</span>
          <span v-else-if="row.shippingstatus == 1" style="color:green">
            已发货
            <i class="fa fa-check"></i>
          </span>
        </template>
        <template slot="ordergoods" slot-scope="{row}">
          <div v-if="row.ordertype =='goods'">
            <p v-for="(item,index) in row.ordergoods" :key="index">
              {{item.goods_name}} {{item.goods_number}} * ￥{{item.promotion_price}}
              <br />
              <span v-if="item.group_buy">
                <span
                  v-if="item.group_buy.iscreated"
                  style="color:blue"
                >[团{{item.group_buy.memberminnum}}][{{item.group_buy.currentmember}}]已成</span>
                <span
                  v-else
                  style="color:red"
                >[团{{item.group_buy.memberminnum}}][{{item.group_buy.currentmember}}]未成</span>

                <span v-if="item.group_buy.status == 1">结束</span>
                <span v-else>进行中</span>
              </span>
            </p>
          </div>
          <div v-else-if="row.ordertype =='recharger'">{{row.remarks}}</div>
        </template>

        <template slot="remarks" slot-scope="{row}">
          <div v-if="row.ordertype =='goods'">{{row.remarks}}</div>
        </template>
        <template slot="address" slot-scope="{row}">
            <span v-for="(item,index) in row.orderdelivery" :key="index">
                {{item.address}} {{item.addressname}} ## {{item.mobile}} ## {{item.consignee}}
            </span>
        </template>

        <template slot="action" slot-scope="{row,index}">
          <button
            type="button"
            class="btn btn-theme m-r-3"
            v-if="row.paystatus == 0"
            @click="fn_refund_order(row,index)"
          >取消订单</button>
          <button
            v-if="row.paystatus == 1 && row.shippingstatus == 0 && row.ordertype =='goods'"
            type="button"
            class="btn btn-theme m-r-3"
            @click="fn_show_order(row)"
          >发货</button>

          <button
            type="button"
            class="btn btn-theme"
            v-if="row.paystatus == 1 && row.shippingstatus == 1 && row.ordertype =='goods'"
            @click="fn_show_delivery(row)"
          >发货信息</button>
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="totalRows"
        :current="filterCond.page"
        :page-size="filterCond.pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPage"
      />
    </panel>
    <Drawer :closable="false" width="70" v-model="v_show">
      <div class="demo-drawer-profile">
        <Form :model="delivery" :labelWidth="120" ref="delivery" :rules="rules">
          <FormItem label="商品">
            <Row>
              <Col span="6" v-for="(item,index) in formData.ordergoods" :key="index">
                <Card style="width:100%">
                  <div style="text-align:center">
                    <img style="width:100%" :src="logourl + item.goods_thumb" />
                    <h5>{{item.goods_name}}</h5>
                  </div>
                </Card>
                <Row>
                  <Col span="24">编号: {{item.goods_sn}}</Col>
                </Row>
                <Row>
                  <Col span="24">
                    规格:
                    <span
                      v-for="(v,k) in item.pricedata"
                      :key="k"
                      style="padding-right:5px"
                    >{{item.attrPluck[v]}}</span>
                  </Col>
                </Row>
                <Row>
                  <Col span="24">价格: ￥{{item.promotion_price}}</Col>
                </Row>
                <Row>
                  <Col span="24">数量: {{item.goods_number}}</Col>
                </Row>
              </Col>
            </Row>
          </FormItem>
          <FormItem
            label="地址"
          >{{deliverydata.address}} {{deliverydata.addressname}} {{deliverydata.consignee}} {{deliverydata.mobile}}</FormItem>
          <Row :gutter="10">
            <Col span="12">
              <FormItem label="快递" prop="deliverycode">
                <Select v-model="delivery.deliverycode">
                  <Option
                    :value="item.corpcode"
                    :label="item.corpname"
                    v-for="(item,index) in expressCorpList"
                    :key="index"
                  ></Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="10">
            <Col span="12">
              <FormItem label="运单号" prop="delivery_sn">
                <Input v-model="delivery.delivery_sn"></Input>
              </FormItem>
            </Col>
          </Row>
          <FormItem>
            <button type="button" class="btn btn-theme" @click="fn_confirm_delivery">发货</button>
          </FormItem>
        </Form>
      </div>
    </Drawer>
    <Drawer :closable="false" width="70" v-model="v_show_delivery">
      <div class="demo-drawer-profile">
        <Form :model="delivery" :labelWidth="120" ref="deliverydata" :rules="rules">
          <FormItem label="商品">
            <Row>
              <Col span="6" v-for="(item,index) in formData.ordergoods" :key="index">
                <Card style="width:100%">
                  <div style="text-align:center">
                    <img style="width:100%" :src="logourl + item.goods_thumb" />
                    <h5>{{item.goods_name}}</h5>
                  </div>
                </Card>
                <Row>
                  <Col span="24">编号: {{item.goods_sn}}</Col>
                </Row>
                <Row>
                  <Col span="24">
                    规格:
                    <span
                      v-for="(v,k) in item.pricedata"
                      :key="k"
                      style="padding-right:5px"
                    >{{item.attrPluck[v]}}</span>
                  </Col>
                </Row>
                <Row>
                  <Col span="24">价格: ￥{{item.promotion_price}}</Col>
                </Row>
                <Row>
                  <Col span="24">数量: {{item.goods_number}}</Col>
                </Row>
              </Col>
            </Row>
          </FormItem>
          <FormItem label="地址">
            <table class="table table-bordered">
              <thead>
                <th>发货地址</th>
                <th>快递</th>
                <th>运单号</th>
                <th>时间</th>
              </thead>
              <tbody>
                <tr v-for="(item,index) in formData.orderdelivery" :key="index">
                  <td>{{item.address}} {{item.addressname}} {{item.consignee}} {{item.mobile}}</td>
                  <td>{{item.deliveryname}}</td>
                  <td>{{item.delivery_sn}}</td>
                  <td>{{item.updated_at}}</td>
                </tr>
              </tbody>
            </table>
          </FormItem>
        </Form>
      </div>
    </Drawer>

    <Modal v-model="v_pay_user" title="付款人信息">
      <p>{{payUser.name}}</p>
      <p>{{payUser.realname}}</p>
      <p v-if="payUser.idcard">{{idCardFormat(payUser.idcard,3,4)}}</p>
      <p>{{payUser.mobile}}</p>
    </Modal>
  </div>
</template>
<script>
import breadcrumb from '@/components/breadcrumb'
import {
  getOrderList,
  storeOrderDeliveryConfirm,
  cancelGoods,
} from '@/api/order'
import { getExpressCorpList } from '@/api/config'
import config from '@/config'
import moment from 'moment'
export default {
  components: { breadcrumb },
  data() {
    return {
      v_pay_user: false,
      logourl: config.baseUrl.imageurl,
      orderdate: [],
      filterCond: {
        begindate: '',
        enddate: '',
        goods_name: '',
        orderstatus: 0,
        shippingstatus: 0,
        paystatus: 99,
        ordertype: 'all',
        page: 1,
        pageNum: 10,
      },
      columns: [
        {
          title: '#ID',
          key: 'id',
          width: 50,
        },
        {
          title: '订单号',
          key: 'order_sn',
          width: 180,
        },
        {
          title: '用户',
          slot: 'users',
          width: 150,
        },
        {
          title: '订单类型',
          slot: 'ordertype',
          width: 100,
        },

        {
          title: '商品',
          slot: 'ordergoods',
          minWidth: 200,
        },
        {
          title: '付款状态',
          slot: 'paystatus',
          width: 100,
        },
        {
          title: '发货状态',
          slot: 'shippingstatus',
          width: 100,
        },
        {
          title: '运费',
          key: 'expressfee',
          width: 100,
        },
        {
          title: '付款方式',
          key: 'paymethodname',
          width: 150,
        },
        {
          title: '订单金额',
          key: 'orderamount',
          width: 120,
        },
        {
          title: '消耗积分',
          key: 'exchangeintegral',
          width: 100,
        },
        {
          title: '备注',
          slot: 'remarks',
          width: 180,
        },
         {
          title: '地址',
          slot: 'address',
          width: 180,
        },
        {
          title: '订单状态',
          slot: 'orderstatus',
          width: 100,
        },
        {
          title: '操作',
          slot: 'action',
          width: 150,
          fixed: 'right',
        },
      ],
      datas: [],
      totalRows: 0,
      formData: {},
      v_show: false,
      expressCorpList: [],
      delivery: {
        orderid: 0,
        deliverycode: '',
        deliveryname: '',
        delivery_sn: '',
      },
      rules: {
        deliverycode: [
          {
            required: true,
            message: '快递必填',
            trigger: 'change',
          },
        ],
        delivery_sn: [
          {
            required: true,
            message: '运单号必填',
            trigger: 'blur',
          },
        ],
      },
      v_show_delivery: false,
      deliverydata: {},
      payUser: {},
    }
  },
  mounted() {
    this.fn_load(this.filterCond)
    getExpressCorpList({ page: 1, pageNum: 0 })
      .then((res) => {
        this.expressCorpList = res.data
      })
      .catch((error) => {
        this.$Message.error(error)
      })
  },
  methods: {
    idCardFormat(str, frontLen, endLen) {
      var len = str.length - frontLen - endLen
      var xing = ''
      for (var i = 0; i < len; i++) {
        xing += '*'
      }
      return (
        str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
      )
    },
    fn_show_payuser(row) {
      this.v_pay_user = true
      this.payUser = row.users
    },
    fn_refund_order(row, index) {
      //人工取消订单
      this.$Modal.confirm({
        title: '确认要取消这个订单?',
        content: '取消订单会恢复数量',
        onOk: () => {
          cancelGoods(row.id).then((res) => {
            if (res.data.code == 200) {
              this.datas.splice(index, 1)
            }
          })
        },
      })
    },
    fn_show_order(row) {
      //   console.log(row);
      for (let index = 0; index < row.ordergoods.length; index++) {
        const element = row.ordergoods[index]

        let attrPluck = {}
        for (
          let index1 = 0;
          index1 < element.goods_price_attr.length;
          index1++
        ) {
          const element1 = element.goods_price_attr[index1]
          attrPluck[element1.id] = element1.name
        }
        row.ordergoods[index].attrPluck = attrPluck
      }

      this.formData = row
      for (let index = 0; index < row.orderdelivery.length; index++) {
        const element = row.orderdelivery[index]
        if (element.status == 0) {
          this.deliverydata = element
          this.delivery.deliverycode = element.deliverycode
          this.delivery.delivery_sn = element.delivery_sn
          break
        }
      }
      this.v_show = true
    },
    fn_query() {
      this.filterCond.page = 1
      this.fn_load(this.filterCond)
    },
    fn_load(filterCond) {
      if (this.orderdate.length > 0) {
        this.filterCond.begindate = moment(this.orderdate[0]).format(
          'YYYY-MM-DD'
        )
        this.filterCond.enddate = moment(this.orderdate[1]).format('YYYY-MM-DD')
      } else {
        this.filterCond.begindate = ''
        this.filterCond.enddate = ''
      }

      getOrderList(filterCond)
        .then((res) => {
          this.datas = res.data.data
          this.totalRows = res.data.total
        })
        .catch((error) => {
          this.$Message.error(error)
        })
    },
    fn_switchPage(page) {
      this.filterCond.page = page
      this.fn_load(this.filterCond)
    },
    fn_confirm_delivery() {
      this.delivery.orderid = this.formData.id
      this.$refs.delivery.validate((valid) => {
        if (valid) {
          storeOrderDeliveryConfirm(this.delivery)
            .then((res) => {
              if (res.data.code == 200) {
                this.formData.orderstatus = 1
                this.v_show = false
              } else {
                this.$Notice.error(res.data)
              }
            })
            .catch((error) => {
              this.$Message.error(error)
            })
        }
      })
    },
    fn_show_delivery(row) {
      for (let index = 0; index < row.ordergoods.length; index++) {
        const element = row.ordergoods[index]

        let attrPluck = {}
        for (
          let index1 = 0;
          index1 < element.goods_price_attr.length;
          index1++
        ) {
          const element1 = element.goods_price_attr[index1]
          attrPluck[element1.id] = element1.name
        }
        row.ordergoods[index].attrPluck = attrPluck
      }

      this.formData = row
      this.v_show_delivery = true
    },
  },
}
</script>